import { FIELDS_KEYS } from '_constants/forms';
import {
  validateAddress,
  validateEmail,
  validateYear,
  validateCardNumber,
  validateCVC,
  validateCardMonth,
  validateCardYear,
  validateCategories,
  validatePhone,
  validateLogoFile,
  validateSpecimenFile,
  validateDescription,
} from './validators';

export const RULES = {
  [FIELDS_KEYS.firstName]: () => {
    return {
      required: 'Please provide First Name',
      pattern: {
        value: /^[ a-zA-Z\\&-]+$/i,
        message: 'Firs Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'First Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.middleName]: () => {
    return {
      pattern: {
        value: /^[ a-zA-Z\\&-]+$/i,
        message: 'Middle Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Middle Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.lastName]: () => {
    return {
      required: 'Please provide Last Name',
      pattern: {
        value: /^[ a-zA-Z\\&-]+$/i,
        message: 'Last Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Last Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.fullName]: () => {
    return {
      required: 'Please provide Full Name',
      pattern: {
        value: /^[ a-zA-Z\\&-]+$/i,
        message: 'Full Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 90,
        message: 'Full Name should be less or equal 90 symbols',
      },
    };
  },
  [FIELDS_KEYS.subject]: () => {
    return {
      required: 'Please provide subject',
    };
  },
  [FIELDS_KEYS.message]: () => {
    return {
      required: 'Please provide message',
      minLength: {
        value: 5,
        message: 'Message length must be between 5 and 2147483647',
      },
      maxLength: {
        value: 2147483647,
        message: 'Message length must be between 5 and 2147483647',
      },
    };
  },
  [FIELDS_KEYS.phone]: (options) => {
    return {
      required: 'Please provide Phone number',
      validate: validatePhone(options),
    };
  },
  [FIELDS_KEYS.address]: (options) => {
    return {
      required: 'Please provide Address',
      pattern: {
        value: /^[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELDS_KEYS.email]: (options) => {
    return {
      required: 'Please provide Email',
      pattern: {
        value:
          /^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i,
        message: 'Email address is not valid',
      },
      validate: validateEmail(options),
    };
  },
  [FIELDS_KEYS.city]: () => {
    return {
      required: 'Please provide City Name',
      pattern: {
        value: /^[ a-zA-Z/-]+$/i,
        message: 'City name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'City name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.state]: () => {
    return {
      required: 'Please select a State/Province',
    };
  },
  [FIELDS_KEYS.zip]: () => {
    return {
      required: 'Please provide a zip code',
      pattern: {
        value: /[0-9]/i,
        message: 'Zip should contain only digits',
      },
      minLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
      maxLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
    };
  },
  [FIELDS_KEYS.markDesc]: ({ defaultMessage }) => {
    return {
      required: defaultMessage || 'Please provide a description',
    };
  },
  [FIELDS_KEYS.literalElements]: () => {
    return {
      required: 'Please provide the description',
    };
  },
  [FIELDS_KEYS.colorsInLogo]: () => {
    return {
      required: 'Please provide the list of colors',
    };
  },
  [FIELDS_KEYS.firstUseAnywhereMonth]: () => {
    return {
      required: 'Please provide Month',
    };
  },
  [FIELDS_KEYS.firstUseAnywhereDay]: () => {
    return {
      required: 'Please provide Day',
    };
  },
  [FIELDS_KEYS.firstUseAnywhereYear]: (options) => {
    return {
      required: 'Please provide Year',
      validate: validateYear(options),
    };
  },
  [FIELDS_KEYS.firstUseInCommerceMonth]: () => {
    return {
      required: 'Please provide Month',
    };
  },
  [FIELDS_KEYS.firstUseInCommerceDay]: () => {
    return {
      required: 'Please provide Day',
    };
  },
  [FIELDS_KEYS.firstUseInCommerceYear]: (options) => {
    return {
      required: 'Please provide Year',
      validate: validateYear(options),
    };
  },
  [FIELDS_KEYS.logoFile]: (options) => {
    const { noValidate } = options || {};

    return {
      required: noValidate ? false : 'Logo file is not chosen',
      validate: validateLogoFile(options),
    };
  },
  [FIELDS_KEYS.trademarkType]: () => {
    return {
      required: 'Please choose the trademark type',
    };
  },
  [FIELDS_KEYS.ownName]: () => {
    return {
      required: 'Please provide the name of the living person',
    };
  },
  [FIELDS_KEYS.translation]: () => {
    return {
      required: 'Please provide the English translation',
    };
  },
  [FIELDS_KEYS.individualOrgOrInd]: () => {
    return {
      required: 'Please choose type of ownership',
    };
  },
  [FIELDS_KEYS.isNonUsBased]: () => {
    return {
      required: 'Please choose formation',
    };
  },
  [FIELDS_KEYS.orgName]: () => {
    return {
      required: 'Please provide Organization Name',
      pattern: {
        value: /[ a-zA-Z0-9/-]/i,
        message:
          'Organization Name should contain only letters, numbers and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Organization Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.orgType]: () => {
    return {
      required: 'Please provide Organization Type',
    };
  },
  [FIELDS_KEYS.otherOrgType]: () => {
    return {
      required: 'Please specify Organization Type',
    };
  },
  [FIELDS_KEYS.orgState]: () => {
    return {
      required: 'Please provide the State of Formation',
    };
  },
  [FIELDS_KEYS.orgPosition]: () => {
    return {
      required: 'Please provide Position',
      pattern: {
        value: /[ a-zA-Z/-]/i,
        message: 'Position should contain only letters, spaces and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Position should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.goodsCategory]: (options) => {
    return {
      required: 'Please choose Category',
      validate: validateCategories(options),
    };
  },
  [FIELDS_KEYS.description]: () => {
    return {
      required: 'Please provide additional description',
      maxLength: {
        value: 90,
        message: 'Description should be less or equal 90 symbols',
      },
    };
  },
  [FIELDS_KEYS.processingOption]: () => {
    return {
      required: 'Please choose a Package',
    };
  },
  [FIELDS_KEYS.productCode]: () => {
    return {
      required: 'Please choose a Package',
    };
  },
  [FIELDS_KEYS.cardNumber]: (options) => {
    return {
      required: 'Please provide Card Number',
      validate: validateCardNumber(options),
    };
  },
  [FIELDS_KEYS.cvc]: (options) => {
    return {
      required: 'Please provide CVC/CVV',
      pattern: {
        value: /[0-9]/i,
        message: 'CVC/CVV should contain only digits',
      },
      minLength: {
        value: 3,
        message: 'CVC/CVV should contain 3 or 4 digits',
      },
      maxLength: {
        value: 4,
        message: 'CVC/CVV should contain 3 or 4 digits',
      },
      validate: validateCVC(options),
    };
  },
  [FIELDS_KEYS.cardMonth]: (options) => {
    return {
      required: 'You should provide Month',
      validate: validateCardMonth(options),
    };
  },
  [FIELDS_KEYS.cardYear]: (options) => {
    return {
      required: 'You should provide Year',
      validate: validateCardYear(options),
    };
  },
  [FIELDS_KEYS.billingAddressAddress1]: (options) => {
    return {
      required: 'Please provide Billing Address',
      pattern: {
        value: /^[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELDS_KEYS.billingAddressCity]: () => {
    return {
      required: 'Please provide City Name',
      pattern: {
        value: /^[ a-zA-Z/-]+$/i,
        message: 'City name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'City name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.billingAddressState]: () => {
    return {
      required: 'Please select a State/Province',
    };
  },
  [FIELDS_KEYS.billingAddressZip]: () => {
    return {
      required: 'Please provide a zip code',
      pattern: {
        value: /[0-9]/i,
        message: 'Zip should contain only digits',
      },
      minLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
      maxLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
    };
  },
  [FIELDS_KEYS.agreeWithTerms]: () => {
    return {
      required: 'You should accept the terms to be able to proceed',
    };
  },
  [FIELDS_KEYS.serialNumber]: () => {
    return {
      required: 'Please provide a valid Serial Number',
    };
  },
  [FIELDS_KEYS.markOwnerFirstName]: () => {
    return {
      required: 'Please provide First Name',
      pattern: {
        value: /^[ a-zA-Z\\&-]+$/i,
        message: 'Firs Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'First Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.markOwnerLastName]: () => {
    return {
      required: 'Please provide Last Name',
      pattern: {
        value: /^[ a-zA-Z\\&-]+$/i,
        message: 'Last Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Last Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.markOwnerPhone]: (options) => {
    return {
      required: 'Please provide Phone number',
      validate: validatePhone(options),
    };
  },
  [FIELDS_KEYS.markOwnerEmail]: (options) => {
    return {
      required: 'Please provide Email',
      pattern: {
        value:
          /^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i,
        message: 'Email address is not valid',
      },
      validate: validateEmail(options),
    };
  },
  [FIELDS_KEYS.newAddress]: (options) => {
    return {
      required: 'Please provide Address',
      pattern: {
        value: /^[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELDS_KEYS.newCity]: () => {
    return {
      required: 'Please provide City Name',
      pattern: {
        value: /^[ a-zA-Z/-]+$/i,
        message: 'City name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'City name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.newState]: () => {
    return {
      required: 'Please select a State/Province',
    };
  },
  [FIELDS_KEYS.newZip]: () => {
    return {
      required: 'Please provide a zip code',
      pattern: {
        value: /[0-9]/i,
        message: 'Zip should contain only digits',
      },
      minLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
      maxLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
    };
  },
  [FIELDS_KEYS.newMarkOwnerFirstName]: () => {
    return {
      required: 'Please provide First Name',
      pattern: {
        value: /^[ a-zA-Z\\&-]+$/i,
        message: 'Firs Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'First Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.newMarkOwnerLastName]: () => {
    return {
      required: 'Please provide Last Name',
      pattern: {
        value: /^[ a-zA-Z\\&-]+$/i,
        message: 'Last Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Last Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.newMarkOwnerDescription]: () => {
    return {
      required: 'Please provide a description',
    };
  },
  [FIELDS_KEYS.classesOrGoodsNotCovered]: () => {
    return {
      required: 'Classes or Goods required',
    };
  },
  [FIELDS_KEYS.itemsCovered]: () => {
    return {
      required: 'Covered items required',
    };
  },
  [FIELDS_KEYS.itemsExtension]: () => {
    return {
      required: 'Extension items required',
    };
  },
  [FIELDS_KEYS.trademarkName]: () => {
    return {
      required: 'Please provide a valid mark',
    };
  },
  [FIELDS_KEYS.classType]: () => {
    return {
      required: 'Please choose type of class',
    };
  },
  [FIELDS_KEYS.isSpecimenNeeded]: () => {
    return {
      required: 'Please choose an option',
    };
  },
  [FIELDS_KEYS.isClassesInUse]: () => {
    return {
      required: 'Please choose an option',
    };
  },
  [FIELDS_KEYS.specimenFile]: (options) => {
    const { noValidate } = options || {};

    return {
      required: noValidate ? false : 'Specimen file is not chosen',
      validate: validateSpecimenFile(options),
    };
  },
  [FIELDS_KEYS.specimenUrl]: () => {
    return {
      required: 'Please provide specimen URL',
    };
  },
  [FIELDS_KEYS.timesDeadlineWasExtended]: () => {
    return {
      required: 'Please provide a number of extensions',
      pattern: {
        value: /[0-9]/i,
        message: 'Number of extensions should contain only digits',
      },
    };
  },
  [FIELDS_KEYS.extensionReason]: () => {
    return {
      required: 'Please select a reason',
    };
  },
  [FIELDS_KEYS.extensionReasonOther]: () => {
    return {
      required: 'Please describe other reason',
    };
  },
  [FIELDS_KEYS.service]: () => {
    return {
      required: 'Please choose an option',
    };
  },
  [FIELDS_KEYS.officeActionStatus]: () => {
    return {
      required: 'Please choose an option',
    };
  },
  [FIELDS_KEYS.statementOfUseStatus]: () => {
    return {
      required: 'Please choose an option',
    };
  },
  [FIELDS_KEYS.privacyPackage]: () => {
    return {
      required: 'Please choose an option',
    };
  },
  [FIELDS_KEYS.logoName]: () => {
    return {
      required: 'Please provide Exact Logo Wording/Business Name',
    };
  },
  [FIELDS_KEYS.businessIndustry]: () => {
    return {
      required: 'Please provide Business Industry',
    };
  },
  [FIELDS_KEYS.businessDescription]: () => {
    return {
      required: 'Please provide Business Description',
    };
  },
  [FIELDS_KEYS.businessProducts]: () => {
    return {
      required: 'Please provide Business Products/Services',
    };
  },
  [FIELDS_KEYS.targetAudience]: () => {
    return {
      required: 'Please provide Target Audience for Customers',
    };
  },
  [FIELDS_KEYS.lettersType]: () => {
    return {
      required: 'Please choose Letters Type for the LOGO',
    };
  },
  [FIELDS_KEYS.customersConception]: (options) => {
    return {
      required: 'Please provide your Conception',
      validate: validateDescription(options),
    };
  },
  [FIELDS_KEYS.logoCategory]: () => {
    return {
      required: 'Please choose LOGO Category',
    };
  },
  [FIELDS_KEYS.logoUse]: () => {
    return {
      required: 'Please choose where the LOGO will be used',
    };
  },
  [FIELDS_KEYS.logoUseDescription]: (options) => {
    return {
      required: 'Please describe where the LOGO will be used',
      validate: validateDescription(options),
    };
  },
};

export const getValidationRules = (fieldKey, options = {}) => {
  const getFieldRule = RULES[fieldKey];
  return getFieldRule ? getFieldRule(options) : undefined;
};
